/** Тарифы в настройках — та же ссылка, что возвращает Stripe после оплаты. */
export const PLANS_HREF = '/settings?section=billing&tab=plan';
